import React from 'react';
import { Icon } from '../../Atoms/Icons';
import RecommendationPipeline from './EventRecommendations/RecommendationPipeline';
import RecommendationPersonDescription from './EventRecommendations/RecommendationPersonDescription';
import { Group, Text, ThemeIcon } from '@mantine/core';
import { IconCheck } from '@tabler/icons';
import { ThemeText } from '../../Atoms/ThemeText';

const RecommendationChild = ({ recommendation, small }) => {
  const { answer, bookingState, lastContactShare } = recommendation;

  const recommendationNotPossible = answer === 'UNAVAILABLE' || bookingState === 'CANCELED';
  const recommendationFinished = answer === 'AVAILABLE' && bookingState === 'BOOKED' && lastContactShare;

  return (
    <div>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', color: '#5E5E5E' }}>
        <RecommendationPersonDescription
          contactId={recommendation.recommendedContactId}
          style={{
            textDecoration: recommendationNotPossible ? 'line-through' : 'none',
            color: recommendationNotPossible ? '#B4B4B4' : '#5E5E5E',
          }}
        />
        <div style={{ display: 'flex' }}>
          {!recommendationNotPossible && !recommendationFinished && (
            <RecommendationPipeline answer={answer} bookingState={bookingState} lastContactShare={lastContactShare} />
          )}
          {recommendationNotPossible && (
            <div style={{ fontSize: 8, display: 'flex' }}>
              <div className="pipeline recommendation stopped failed">
                <div style={{ border: '1px solid #ffffff', borderRadius: 5, width: 5 }} />
              </div>{' '}
              <Text color="dimmed" style={{ marginLeft: 5 }}>
                Vermittlung nicht möglich
              </Text>
            </div>
          )}
          {recommendationFinished && (
            <Group position="left">
              <ThemeIcon radius="xl" size="sm">
                <IconCheck size={16} />
              </ThemeIcon>
              <ThemeText>Vermittlung abgeschlossen</ThemeText>
            </Group>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecommendationChild;
